import { FETCH_USERS } from '../types/user';

const initialState = {
users: []
};


/* store generation users  with type FETCH_USERS 
users: [],

case FETCH_USERS :
    return { ...state, users: [action.payload] };




*/
export default (state = initialState , action) =>{
switch (action.type) {

case FETCH_USERS :
    return { ...state, users: [action.payload] };

default:
    return state ;
}
};